import { Radio, RadioChangeEvent, Space } from 'antd';
import classNames from 'classnames';
import { CustomRadioGroupProps } from '../../interfaces';
import CustomRadio from '../controls/Radio';
import './styles.scss';

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = props => {
  const {
    options,
    onChange,
    className,
    wrap = true,
    customType = 'primary',
    customDirection = 'horizontal',
    radioType = 'sticky',
    ...rest
  } = props;

  const handleChange = ({ target: { value } }: RadioChangeEvent) => {
    onChange?.(value);
  };

  const newClassName = classNames('custom-radio-group', className, {
    primary: customType === 'primary',
    linkage: customType === 'linkage',
  });

  return (
    <Radio.Group {...rest} onChange={handleChange} className={newClassName}>
      {radioType === 'sticky' ? (
        options?.map((option, index) => (
          <CustomRadio {...option} key={index} type={customType}>
            {option.label}
          </CustomRadio>
        ))
      ) : (
        <Space direction={customDirection} wrap={wrap}>
          {options?.map((option, index) => (
            <CustomRadio {...option} key={index} type={customType}>
              {option.label}
            </CustomRadio>
          ))}
        </Space>
      )}
    </Radio.Group>
  );
};

export default CustomRadioGroup;
